export const routes = (prefix = `suppliers-dashboard`) => [
    {
        path: `/${prefix}/invoice-list`,
        name: `${prefix}.invoice-list.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.invoice-list.index`,
                PageDescription: "Supplier Module: Invoice",
            },
        },
    },
    {
        path: `/${prefix}/invoice-list/create/:invoiceNo`,
        name: `${prefix}.invoice-list.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.invoice-list.index`,
                PageDescription: "Supplier Module: Invoice",
            },
        },
    },
    {
        path: `/${prefix}/invoice-list/view/:invoiceNo`,
        name: `${prefix}.invoice-list.view`,
        component: () => import('./View.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.invoice-list.index`,
                PageDescription: "Supplier Module: Invoice",
            },
        },
    },
    // {
    //     path: `/${prefix}/invoice-list/print/:invoiceNo`,
    //     name: `${prefix}.invoice-list.print`,
    //     component: () => import('./Print.vue'),
    //     meta: {
    //         requiresAuth: true,
    //         permissions: {
    //             PageName: `${prefix}.invoice-list.index`,
    //             PageDescription: "Supplier Module: Invoice",
    //         },
    //         print: true,
    //     },
    // },
    {
        path: `/${prefix}/invoice-list/print/:invoiceNo`,
        name: `${prefix}.invoice-list.print`,
        component: () => import('./Print.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.invoice-list.index`,
                PageDescription: "Supplier Module: Invoice",
            },
            print: true,
        },
    },
];